import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";

const initialState = {};

const lifeExtraDataSlice = createSlice({
  name: "lifeExtraData",
  initialState,
  reducers: {
    setLifeExtraData(state, action) {
      state.lifeExtraData = action.payload;
    }
  }
});

const { actions, reducer } = lifeExtraDataSlice;

export const { setLifeExtraData } = actions;

export const setLifeExtraDataAction = (data) => async (dispatch) => {
  dispatch(setLifeExtraData(data));
};

export default reducer;
